module.exports = __webpack_public_path__ + "static/media/iconFive.1c034300.svg";